


















import { Vue, Component } from 'vue-property-decorator';

import api, { ReferalApi } from './api';
import InvitedUsers from './forms/invited-users.vue';
import ReferralBalance from './forms/referral-balance.vue';


@Component({
  components: {
    InvitedUsers,
    ReferralBalance,
  }
})

export default class ReferralProgram extends Vue {
  tabReferral: number = null;
  api: ReferalApi = api;

  get tabs() {
    return [
      {
        label: this.t('Invited Users'),
        key: 'invitedUsers',
      },
      {
        label: this.t('Referral Balance'),
        key: 'referralBalance',
      },
    ]
  }
}
